<template>
	<div>
		<q-dialog v-model="dialog" persistent transition-show="scale" transition-hide="scale">
			<div class="hris-modal">
				<q-form ref="vForm" @submit="addUser">
					<div class="hris-modal-header">
						<h2 class="hris-modal-title">Add User</h2>
						<q-btn icon="fas fa-times" flat round dense v-close-popup class="hris-q-ghost" @click="closeModal"></q-btn>
					</div>
					<div class="hris-modal-body">
						<div class="hris-form-row">
							<div class="hris-form-field">
								<q-input outlined dense color="green" v-model="models.firstname" label="First Name" class="caps"></q-input>
							</div>
							<div class="hris-form-field">
								<q-input outlined dense color="green" v-model="models.middlename" label="Middle Name" class="caps"></q-input>
							</div>
						</div>
						<div class="hris-form-row">
							<div class="hris-form-field">
								<q-input outlined dense color="green" v-model="models.lastname" label="Last Name" class="caps"></q-input>
							</div>
							<div class="hris-form-field">
								<q-input outlined dense color="green" v-model="models.email" label="Email"></q-input>
							</div>
						</div>
						<div class="hris-form-row">
							<div class="hris-form-field">
								<q-select outlined dense color="green" v-model="models.role" option-value="role_id" option-label="name" :options="ranks" label="Rank" emit-value map-options class="caps"></q-select>
							</div>
						</div>
						<div class="hris-form-row">
							<div class="hris-form-field">
								<q-input outlined dense color="green" v-model="models.username" label="Username"></q-input>
							</div>
							<div class="hris-form-field">
								<q-input outlined dense color="green" v-model="models.password" type="password" label="Password"></q-input>
							</div>
						</div>
					</div>
					<div class="hris-modal-footer">
						<q-btn flat label="Close" class="hris-q-ghost" @click="closeModal"></q-btn>
						<q-btn unelevated label="Submit" type="submit" class="hris-q-primary"></q-btn>
					</div>
				</q-form>
			</div>
		</q-dialog>
		<q-dialog v-model="spinner" persistent>
			<div class="hris-loading" style="background: #fff; border-radius: 14px; padding: 32px 44px;">
				<q-spinner color="green" size="40px"></q-spinner>
			</div>
		</q-dialog>
	</div>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';

export default {

	data() {
		return {
			spinner: false,
			models : {
				firstname:null,
				middlename:null,
				lastname:null,
				username:null,
				email:null,
				password:null,
				role:null
			},
			dialog: false,
			ranks:[]
		}
	},
	created(){
		this.eventHub.$on('AddUserAccount', this.openModal);
		this.displayRanks()
	},

	methods: {
		addUser:function(){
			this.spinner=true;
			let formData = new FormData();
			formData.append("firstname", this.models.firstname);
			formData.append("middlename", this.models.middlename);
			formData.append("lastname", this.models.lastname);
			formData.append("username", this.models.username);
			formData.append("email", this.models.email);
			formData.append("role", this.models.role);
			formData.append("password", this.models.password);
			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('/admin/create',formData)
			.then((res) => {
				this.spinner=false;

				if(res.data.status){
					this.$refs.vForm.reset()
					this.resetForm()
					this.$q.notify({
						message: 'User successfully created.',
						color: 'positive',
						actions: [
					{ label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
					]
				})
					this.eventHub.$emit('refreshEmployeeList',"");
				}else{
					this.$q.notify({
						message: 'Failed to create a user.',
						color: 'negative',
						actions: [
					{ label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
					]
				})
				}
				return true;
				
			});
		},

		openModal:function(){
			this.dialog = true
		},

		closeModal:function(){
			this.dialog = false
		},

		displayRanks: function() {
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/admin/users`)
			.then((res) => {
				
				this.ranks = res.data.ranks
				this.ranks.unshift({'role_id':1,'name':'ALL'})			
			})

		},

		resetForm:function(){
			var self = this;
			Object.keys(this.models).forEach(function(key, index) {
				self.models[key] = '';
			});
		},
	}
}
</script>
<style lang="css" scoped>
</style>
